<template>
  <div class="ut-container-sm ut-py-10 ut-relative">
    <div class="header-back-btn ga-event"
        data-category="Lead"
         @click="navigateToLeads">
         LEADS</div>

    <div class="ut-flex ut-pt-8 md:ut-relative">
      <first-initial-name class="ut-mt-0" :str="lead.firstname"></first-initial-name>
      <div class="vendor-info ut-ml-0">
        <h1 class="vendor-name">{{ leadName }}</h1>
        <p class="vendor-address">{{ leadAddress }}</p>
        <hr/>
        <div class="vendor-contact-details">
          <click-to-show :email="false"
                        :str="lead.phone"
                        :formate="lamStageIsEqualOrMoreThanAttempted"
                        @clicked-show="clickedShow"
                        :isvendor="true"
                        gacategory="Lead"
                        gaeventlabel="Phone number"
                        :gaeventvalue="leadKey"
                        gaeventvaluetype="lead key">
          </click-to-show>
          <click-to-show :email="true"
                        :str="lead.email"
                        :formate="lamStageIsEqualOrMoreThanAttempted"
                        @clicked-show="clickedShow"
                        :isvendor="true"
                        gacategory="Lead"
                        gaeventlabel="Email Address"
                        :gaeventvalue="leadKey"
                        gaeventvaluetype="lead key">
          </click-to-show>
        </div>
      </div>
      <ul class="lead-status-buttons">
        <li @click="showModal('message-lead-modal')">
          <img src="@/assets/styles/frontend-library/images/message-white-solid.svg"
               width="24"
               alt="Edit" />
        </li>
        <li v-bind:class="[{disabled: isdisableOnHoldAndClose }]"
            @click="togglePutLeadOnHold">
          <img v-if="lamIsOnHold"
               src="@/assets/styles/frontend-library/images/play-white.svg"
               alt="Play"
               height="18" />
          <img v-else src="@/assets/styles/frontend-library/images/pause-white.svg"
               alt="Pause"
               height="18" />
        </li>
        <li v-bind:class="[{disabled: isdisableOnHoldAndClose }]"
            @click="showModal('close-lead-modal')">
          <img src="@/assets/styles/frontend-library/images/close-white.svg"
                width="24"
               alt="Close" />
        </li>
      </ul>
    </div>
    <info-card
      class="ut-mt-4"
      v-if="!isLamOwner"
      :info="lamOwnerInfo"
    />
  </div>
</template>

<script>

import {
 mapState, mapActions, mapMutations, mapGetters 
} from 'vuex';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import ClickToShow from '@/components/ClickToShow.vue';
import FirstInitialName from '@/components/FirstInitialName.vue';
import InfoCard from '@/components/Cards/InfoCard.vue';
import { LeadStateType } from '@/Mapper/LeadStateType';
import { LeadStageType } from '@/Mapper/LeadStageType';

export default {
  name: 'LeadHeader',
  components: {
    ClickToShow,
    FirstInitialName,
    InfoCard,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
    ...mapGetters('leadAgentMappingStore', [
      'lamIsClosed',
      'lamIsLost',
      'lamIsActive',
      'lamIsListed',
      'lamIsOnHold',
      'lamStageIsLessThanAttempted',
      'lamStageIsEqualOrMoreThanAttempted',
      'lamStageIsAttempted',
      'lamStageIsContacted',
      'lamStageIsListed',
    ]),
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
    leadName() {
      return `${this.lead.firstname}${this.lead.lastname ? ` ${this.lead.lastname}` : ''}`;
    },
    leadAddress() {
      return `${this.lead.streetaddress}, ${this.lead.suburb} ${
        this.lead.state
      } ${this.lead.postcode}`;
    },
    leadAddress() {
      return `${this.lead.streetaddress}, ${this.lead.suburb} ${
        this.lead.state
      } ${this.lead.postcode}`;
    },
    leadKey() {
      return `${this.lead.key}`;
    },
    isdisableOnHoldAndClose() {
      // Make inactive if leadStateType is closed (), or leadStageType is listed
      return this.lamIsLost || this.lamIsClosed || (this.lamIsActive && this.lamStageIsListed);
    },
    isLamOwner() {
      return !!this.agent && this.agent.key === this.$route.params.ak
        && ((!!this.$route.params.uk
          && this.$route.params.uk == this.lam.agentuserkey)
          || !this.$route.params.uk);
    },
    lamOwnerInfo() {
      return `We recommended another agent on ${this.$helpers.formatDate(this.lam.agentsentleaddate, 'D MMM YYYY hh:mma')}.`;
    },
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
    ]),
    ...mapMutations('leadAgentMappingStore', [
      'setLeadAgentMapping',
    ]),
    navigateToLeads() {
      this.$router.push({
        path: `${this.agent.key ? `/${this.agent.key}` : ''}/leads${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
      });
    },
    clickedShow() {
      // Create a new contact attempt with current date
      const contactAttemptData = {
        contactattemptinitiatortypeid: this.isLamOwner ? 2 : 3,
        contactattemptoutcometypeid: 3, // 1=Unknown 2=Success 3=No Contact 4=Left voicemail
        contactattemptdate: this.$helpers.formatDateTimeApi(new Date()),
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
      };
      this.$apiServices.oa.leadAgent.createContactAttempt(contactAttemptData)
        .then((result) => {
        // Refresh contact attempts list
          this.$emit('new-contact-attempt', result);
          // Set agent stage to attempted if stage is referred or accepted
          if (this.lamStageIsLessThanAttempted) {
            this.moveToAttempted()
              .then((attemptResult) => {
              // this.logLeadEvent('Leads Management - Submit status change - Attempted');
                this.disableSubmit = false;
                const updatedLam = this.lam;
                updatedLam.agentlastupdatedate = attemptResult.createddate;
                this.setLeadAgentMapping(updatedLam);
              }).catch((err) => {
                console.log(err);
                this.disableSubmit = false;
              });
          } else {
            this.disableSubmit = false;
          }
        });
    },
    moveToAttempted() {
      const payload = {
        lamid: this.lam.id,
        data: {
          stagetypeid: LeadAgentLeadStageType.Attempted,
          oauserid: this.user ? this.user.id : '',
          oauserkey: this.user ? this.user.key : '',
          sourcetypeid: this.isLamOwner ? 1 : 3,
        },
      };
      return this.updateLeadAgentMapping(payload);
    },
    showModal(name) {
      if (!this.isdisableOnHoldAndClose || name === 'message-lead-modal') {
        this.$modal.show(name);
      }
    },
    togglePutLeadOnHold() {
      if (this.isdisableOnHoldAndClose) {
        return false;
      }

      if (!this.lamIsOnHold) {
        this.showModal('on-hold-modal');
      } else {
        this.reactivateLam();
      }

      return true;
    },
    reactivateLam() {
      const payload = {
        lamid: this.lam.id,
        data: {
          statetypeid: LeadAgentLeadStateType.Active,
          oauserid: this.user ? this.user.id : '',
          oauserkey: this.user ? this.user.key : '',
          sourcetypeid: this.isLamOwner ? 1 : 3,
        },
      };
      this.$store
        .dispatch('leadAgentMappingStore/updateLeadAgentMapping', payload)
        .then(() => {
        // this.closeModal();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.header-back-btn {
  @apply ut-inline-block ut-cursor-pointer;
  font-size: 12px;
  letter-spacing: 1.07px;
  line-height: 15px;

  &:before {
    @apply ut-inline-block ut-mr-8;
    content: url("../assets/styles/frontend-library/images/back-arrow.svg");
    vertical-align: middle;
    line-height: 15px;
  }
}

.vendor-info {

  @screen md {
    margin-right: 192px;
  }

  hr {
    @apply ut-w-5/6 ut-my-3 ut-ml-0;
    border-top: 1px solid #D6D5D2;
  }

  .vendor-name {
    @apply ut-font-bold;
    font-size: 24px;
    line-height: 36px;

    @screen md {
      font-size: 28px;
    }
  }

  .vendor-address {
    font-size: 16px;
    letter-spacing: 0.26px;
    line-height: 24px;
    color: #545352;
  }

  .vendor-contact-details {

  }

}


.lead-status-buttons {
  @apply ut-absolute ut-top-0 ut-right-0 ut-pt-10 ut-pr-4 ut-flex ut-content-start;

  @screen md {
    @apply ut-pt-8;
  }

  li {
    @apply ut-rounded-full ut-overflow-hidden ut-flex ut-content-center ut-cursor-pointer;
    width: 48px;
    height: 48px;
    @apply ut-bg-green-400;

    &.disabled {
      @apply ut-opacity-50 ut-cursor-not-allowed;
      background-color: #545352;
    }

    &:nth-child(even) {
      @apply ut-mx-1;

      img {
           height: 18px;
      }
    }

  }

}

</style>
